<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-text-box-multiple-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Details
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrgAppModules()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-application-cog
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              App Modules
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrgSubscriptions()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-calendar-month
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Subscriptions
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-btn
      color="red darken-3"
      class="ml-7 my-back-btn-style"
      text
      x-large
      dark
      @click="back()"
    >
      <v-icon
        left
        dark
      >
        mdi-arrow-left-bold
      </v-icon>
      Back
    </v-btn>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-domain
                </v-icon>
              </v-list-item-icon>
              Organization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-text-box-multiple-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Details
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrgAppModules()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-application-cog
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              App Modules
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getOrgSubscriptions()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-calendar-month
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Subscriptions
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <organization-details v-if="showOrganizationDetails" />
    <org-app-modules v-if="showOrgAppModules" />
    <org-subscriptions v-if="showOrgSubscriptions" />
  </v-container>
</template>
<script>
  import OrganizationDetails from 'src/views/dashboard/organizations/OrganizationDetails.vue';
  import OrgAppModules from './OrgAppModules.vue';
  import OrgSubscriptions from './OrgSubscriptions.vue';

  export default {
    name: 'OrganizationDetailsLandingPage',
    components: {
      'organization-details': OrganizationDetails,
      'org-app-modules': OrgAppModules,
      'org-subscriptions': OrgSubscriptions,
    },
    data: () => ({
      selectedItem: -1,
      showOrganizationDetails: true,
      showOrgAppModules: false,
      showOrgSubscriptions: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getOrganizationDetails () {
        this.showOrgAppModules = false;
        this.showOrgSubscriptions = false;
        this.showOrganizationDetails = true;
      },
      back () {
        this.$router.push({ name: 'Organizations' });
      },
      getOrgAppModules () {
        this.showOrganizationDetails = false;
        this.showOrgSubscriptions = false;
        this.showOrgAppModules = true;
      },
      getOrgSubscriptions () {
        this.showOrganizationDetails = false;
        this.showOrgAppModules = false;
        this.showOrgSubscriptions = true;
      },
    },
  };
</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
.my-back-btn-style {
  margin-bottom: -20px;
}
@media (max-width: 960px) {
  .my-back-btn-style {
    margin-bottom: 0px;
    margin-left: 0px !important;
  }
}
</style>
